//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    title: "تواصل معنا",
    // description:
    //   "منصة متجرة لمواقع و تطبيقات المتاجر الإلكترونية هي منصة سعودية مسجلة بوزارة التجارة و الإستثمار السعودية ( مؤسسة المستشار لتقنية المعلومات ) تحت سجل التجاري رقم: 4030372176",

    valid: true,
    name: "",
    nameRules: [(v) => !!v || "الاسم مطلوب"],
    email: "",
    emailRules: [
      (v) => !!v || "البريد الالكتروني مطلوب",
      (v) => /.+@.+\..+/.test(v) || "يجب ان يكون البريد الاكتروني صحيح",
    ],
    message: "",
    messageRules: [(v) => !!v || "الرسالة مطلوب"],

    action: "https://mailthis.to/form@tajadad.app",
    form: {
      name: null,
      message: "",
      _replyto: "",
      _subject: "",
      _after: "",
      _honeypot: "",
      _confirmation: "",
    },
    submitting: null,
    error: null,
    success: null,
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        try {
          await this.$axios.$post(this.action, this.form);
          this.error = false;
          this.success = true;
          this.form = {};
          requestAnimationFrame(() => {
            this.$refs.form.reset();
          });
        } catch (error) {
          this.error = true;
        } finally {
          this.submitting = false;
        }
      }
    },
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale", // open graph type
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type", // open graph type
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title", // open graph title
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description", // open graph description
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url", // open graph url
          property: "og:url",
          content: "https://tajadad.app/contact-us",
        },
        {
          hid: "og:site_name", // open graph site_name
          property: "og:site_name",
          content: "متجرة",
        },
        {
          hid: "og:updated_time", // open graph updated_time
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image", // open graph image
          property: "og:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
        {
          hid: "apple-mobile-web-app-title", // open graph mobile web app title
          name: "apple-mobile-web-app-title",
          content: this.title,
        },

        // open graph twitter
        { name: "twitter:site", content: "@Tajadad" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://tajadad.app/contact-us",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://tajadad.app/contact-us",
        },
      ],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://tajadad.app/#organization",
          "url": "https://tajadad.app/",
          "name": "منصة متجرة",
          "alternateName": "منصة متجرة",
          "description":
            "منصة متجرة بتقدملك أسرع وأسهل تجربة لإنشاء متجر الكتروني بدون تعقيد وبخطوات بسيطة",
          "logo": {
            "@type": "ImageObject",
            "url": "https://tajadad.app/tajadad.jpg",
          },
          "image": {
            '@type': 'ImageObject',
            "url": "https://tajadad.app/tajadad.jpg",
          },
          "contactPoint": [
            // {
            //   "@type": "ContactPoint",
            //   "telephone": "920033179",
            //   "contactType": "customer service"
            // }
          ]
        },
      ]
    }

  }
};
